module.exports = __webpack_public_path__ + "static/media/podium.4c3f2111.svg";